// extracted by mini-css-extract-plugin
export var hamburger = "hamburger-module--hamburger--25706";
export var hamburger3dx = "hamburger-module--hamburger-3dx--49c88";
export var hamburger3dxR = "hamburger-module--hamburger-3dx-r--77698";
export var hamburger3dxy = "hamburger-module--hamburger-3dxy--bb37e";
export var hamburger3dy = "hamburger-module--hamburger-3dy--8b40a";
export var hamburger3dyR = "hamburger-module--hamburger-3dy-r--1a909";
export var hamburgerBox = "hamburger-module--hamburger-box--06e20";
export var hamburgerCollapse = "hamburger-module--hamburger-collapse--edb51";
export var hamburgerInner = "hamburger-module--hamburger-inner--bbf69";
export var hamburgerSqueeze = "hamburger-module--hamburger-squeeze--a4f32";
export var isActive = "hamburger-module--is-active--756a8";
export var light = "hamburger-module--light--6b2fa";